import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Helmet from 'react-helmet';
import { RouteConfig } from '../type';

interface SubRouterProps {
    routes?: RouteConfig[];
}

const APP_TITLE_SUFFIX = 'Suits Me Banking';

const SubRouter = ({ routes = [] }: SubRouterProps) => (
    <Routes>
        {routes.map(({ path = '', element, pageTitle }) => (
            <Route
                key={path}
                path={path}
                element={
                    <>
                        <Helmet>
                            <title>
                                {pageTitle ? `${pageTitle} | ${APP_TITLE_SUFFIX}` : APP_TITLE_SUFFIX}
                            </title>
                        </Helmet>
                        {element}
                    </>
                }
            />
        ))}
    </Routes>
);

export default SubRouter;
